export default "__VITE_ASSET__CObZGcnU__"